module.exports = __webpack_public_path__ + "img/planetary-rev01.ef56290a.jpg";